module.exports = __webpack_public_path__ + "img/exit-icon.b6afd70b.svg";